import 'babel-polyfill'
import objectFitImages from 'object-fit-images'

import React, {Component} from 'react'
import {render} from 'react-snapshot'
import App from './App'
import ToC from './ToC'
import './index.css'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import {addLocaleData, IntlProvider} from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'
import esLocaleData from 'react-intl/locale-data/es'
import messages from './messages.js'

window.addEventListener('DOMContentLoaded', () => {
  objectFitImages()
})

addLocaleData(enLocaleData)
addLocaleData(esLocaleData)

const parseLocale = (locale) => {
  const parts = locale.split(/-/)
  const lang = parts[0]
  const location = parts[1] && parts[1].toUpperCase()
  return { lang, locale: location ? `${lang}-${location}` : lang }
}

class Root extends Component {
  render () {
    const {lang, locale} = parseLocale(this.props.match.params.locale)

    return (
      <IntlProvider locale={locale} messages={messages[lang]}>
        <App locale={locale} lang={lang}>{this.props.children}</App>
      </IntlProvider>
    )
  }
}

render(
  (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={ToC} />
          <Route path='/:locale' component={Root} />
        </Switch>
      </BrowserRouter>
  ),
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js